"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const JoloDidDocument_1 = __importDefault(require("./JoloDidDocument"));
const ElemDidDocument_1 = __importDefault(require("./ElemDidDocument"));
const did_resolver_1 = require("did-resolver");
class DidDocumentService {
    constructor(keysService) {
        const { didMethod } = keysService.decryptSeed();
        let didDocumentService;
        switch (didMethod) {
            case 'jolo':
                didDocumentService = new JoloDidDocument_1.default(keysService);
                break;
            case 'elem':
                didDocumentService = new ElemDidDocument_1.default(keysService);
                break;
        }
        return didDocumentService;
    }
    getMyDid() {
        return 'did:...';
    }
    getKeyId(did = null) {
        if (!did) {
            did = this.getMyDid();
        }
        const signingKey = 'primary';
        return `${did}#${signingKey}`;
    }
    buildDidDocument() {
        return __awaiter(this, void 0, void 0, function* () {
            return { id: 'did:...' };
        });
    }
    static getPublicKey(fulleKeyId, didDocument, keyId) {
        // Support finding the publicKey with the short form DID + fragment or full keyId
        if (!keyId) {
            const { did, fragment } = did_resolver_1.parse(fulleKeyId);
            keyId = `${did}#${fragment}`;
        }
        const keySection = didDocument.publicKey.find((section) => section.id === keyId || section.id === fulleKeyId);
        if (!keySection) {
            throw new Error('Key not found.');
        }
        return Buffer.from(keySection.publicKeyHex, 'hex');
    }
    /** NOTE: https://www.w3.org/TR/2019/WD-did-core-20191209/#generic-did-syntax
      This should support (see NEP-335):
        1. fragmet: "did:example:123456#oidc"
        2. query: "did:example:123456?query=true"
        3. path: "did:example:123456/path"
        4. parameters: "did:example:21tDAKCERh95uGgKbJNHYp;service=agent;foo:bar=high"
    */
    static parseDid(did) {
        const [, method, methodId, parameters] = did.split(':');
        return [method, methodId, parameters];
    }
    static keyIdToDid(keyId) {
        if (keyId.indexOf('#') === -1) {
            return keyId;
        }
        return keyId.substring(0, keyId.indexOf('#'));
    }
}
exports.default = DidDocumentService;
//# sourceMappingURL=index.js.map